
(function() {
  var result = { translations: { "it": { "SharedI18nStrings": { "languageNames": { "af": "Afrikaans", "sq": "Albanese", "sq-al": "Albanese - Albania", "ar": "Arabo", "ar-dz": "Arabo - Algeria", "ar-bh": "Arabo - Bahrein", "ar-eg": "Arabo - Egitto", "ar-iq": "Arabo - Iraq", "ar-jo": "Arabo - Giordania", "ar-kw": "Arabo - Kuwait", "ar-lb": "Arabo - Libano", "ar-ly": "Arabo - Libia", "ar-ma": "Arabo - Marocco", "ar-om": "Arabo - Oman", "ar-qa": "Arabo - Qatar", "ar-sa": "Arabo - Arabia Saudita", "ar-sd": "Arabo - Sudan", "ar-sy": "Arabo - Siria", "ar-tn": "Arabo - Tunisia", "ar-ae": "Arabo - Emirati Arabi Uniti", "ar-ye": "Arabo - Yemen", "as": "Assamese", "az": "Azerbaigiano", "hy": "Armeno", "eu": "Basco", "be": "Bielorusso", "be-by": "Bielorusso - Bielorussia", "bn": "Bengali", "bg": "Bulgaro", "bg-bg": "Bulgaro - Bulgaria", "bs": "Bosniaco", "ca": "Catalano", "ca-es": "Catalano - Catalogna", "zh": "Cinese", "zh-cn": "Cinese - Semplificato", "zh-hk": "Cinese - Hong Kong", "zh-mo": "Cinese - Macao", "zh-sg": "Cinese - Singapore", "zh-tw": "Cinese - Tradizionale", "zh-chs": "Cinese (semplificato)", "zh-cht": "Cinese (tradizionale)", "zh-hans": "Cinese (Han semplificato)", "zh-hant": "Cinese (Han tradizionale)", "hr": "Croato", "hr-hr": "Croato - Croazia", "cs": "Ceco", "cs-cz": "Ceco - Repubblica ceca", "da": "Danese", "da-dk": "Danese - Danimarca", "nl": "Olandese", "nl-be": "Olandese - Belgio", "nl-ch": "Olandese - Svizzera", "nl-lu": "Olandese - Lussemburgo", "nl-nl": "Olandese - Paesi Bassi", "en": "Inglese", "en-ae": "Inglese - Emirati Arabi Uniti", "en-au": "Inglese - Australia", "en-be": "Inglese - Belgio", "en-ca": "Inglese - Canada", "en-ch": "Inglese - Svizzera", "en-cn": "Inglese - Cina", "en-de": "Inglese - Germania", "en-ee": "Inglese - Estonia", "en-es": "Inglese - Spagna", "en-fr": "Inglese - Francia", "en-hk": "Inglese - Hong Kong", "en-in": "Inglese - India", "en-ie": "Inglese - Irlanda", "en-ke": "Inglese - Kenia", "en-lu": "Inglese - Lussemburgo", "en-my": "Inglese - Malesia", "en-mt": "Inglese - Malta", "en-mx": "Inglese - Messico", "en-nl": "Inglese - Paesi Bassi", "en-nz": "Inglese - Nuova Zelanda", "en-ph": "Inglese - Filippine", "en-pk": "Inglese - Pakistan", "en-se": "Inglese - Svezia", "en-sg": "Inglese - Singapore", "en-tn": "Inglese - Tunisia", "en-za": "Inglese - Sud Africa", "en-gb": "Inglese - Regno Unito", "en-us": "Inglese - Stati Uniti", "en-zw": "Inglese - Zimbabwe", "et": "Estone", "et-ee": "Estone - Estonia", "fo": "Faroese", "fa": "Farsi", "fi": "Finlandese", "fi-fi": "Finlandese - Finlandia", "fil": "Filippino", "fr": "Francese", "fr-be": "Francese - Belgio", "fr-ca": "Francese - Canada", "fr-fr": "Francese - Francia", "fr-lu": "Francese - Lussemburgo", "fr-mc": "Francese - Marocco", "fr-ch": "Francese - Svizzera", "fr-tn": "Francese - Tunisia", "gl": "Gallego", "ka": "Georgiano", "de": "Tedesco", "de-at": "Tedesco - Austria", "de-de": "Tedesco - Germania", "de-gr": "Tedesco - Grecia", "de-li": "Tedesco - Liechtenstein", "de-lu": "Tedesco - Lussemburgo", "de-ch": "Tedesco - Svizzera", "el": "Greco", "el-cy": "Greco - Cipro", "el-gr": "Greco - Grecia", "gu": "Gujarati", "haw": "Hawaiano", "ha": "Hausa", "he": "Ebraico", "he-il": "Ebraico - Israele", "iw-il": "Ebraico - Israele", "hi": "Hindi", "hi-in": "Hindi - India", "hu": "Ungherese", "hu-hu": "Ungherese - Ungheria", "is": "Islandese", "is-is": "Islandese - Islanda", "id": "Indonesiano", "in-id": "Indonesiano - Indonesia", "ga": "Irlandese", "ga-ie": "Irlandese - Irlanda", "it": "Italiano", "it-it": "Italiano - Italia", "it-ch": "Italiano - Svizzera", "ja": "Giapponese", "ja-jp": "Giapponese - Giappone", "kn": "Kannada", "kk": "Kazako", "kok": "Konkani", "ko": "Coreano", "ko-kr": "Coreano - Corea del sud", "ku": "Curdo", "ky": "Kirghiso", "ky-kg": "Kirghiso", "lo": "Laotiano", "lv": "Lettone", "lv-lv": "Lettone - Lettonia", "lt": "Lituano", "lt-lt": "Lituano - Lituania", "mk": "Macedone", "mk-mk": "Macedone - Macedonia", "ml": "Malayalam", "ms": "Malese", "ms-bn": "Malese - Brunei", "ms-my": "Malese - Malesia", "mt": "Maltese", "mt-mt": "Maltese - Malta", "mr": "Marathi", "mn": "Mongolo", "my": "Lingua birmana", "my-mm": "Lingua birmana - (Birmania)", "ne": "Nepalese", "no": "Norvegese", "nb": "Norvegese Bokm\xE5l", "nb-no": "Bokmal norvegese - Norvegia", "no-no": "Norvegese - Norvegia", "pl": "Polacco", "pl-pl": "Polacco - Polonia", "pt": "Portoghese", "pt-br": "Portoghese - Brasile", "pt-pt": "Portoghese - Portogallo", "pa": "Pangiabi", "pa-in": "Punjabi - India", "pa-pk": "Punjabi - Pakistan", "ro": "Rumeno", "ro-ro": "Romeno - Romania", "ru": "Russo", "ru-ru": "Russo - Russia", "rw-rw": "Kinyarwanda", "sa": "Sanscrito", "si": "Singalese", "sr": "Serbo", "sr-ba": "Serbo - Bosnia ed Erzegovina", "sr-me": "Serbo - Montenegro", "sr-rs": "Serbo - Serbia", "sr-cs": "Serbo - (Ex) Serbia e Montenegro", "sk": "Slovacco", "sk-sk": "Slovacco - Slovacchia", "sl": "Sloveno", "sl-si": "Sloveno - Slovenia", "es": "Spagnolo", "es-ar": "Spagnolo - Argentina", "es-bo": "Spagnolo - Bolivia", "es-cl": "Spagnolo - Cile", "es-co": "Spagnolo - Colombia", "es-cr": "Spagnolo - Costa Rica", "es-cu": "Spagnolo - Cuba", "es-do": "Spagnolo - Repubblica Dominicana", "es-ec": "Spagnolo - Ecuador", "es-sv": "Spagnolo - El Salvador", "es-gt": "Spagnolo - Guatemala", "es-hn": "Spagnolo - Honduras", "es-mx": "Spagnolo - Messico", "es-ni": "Spagnolo - Nicaragua", "es-pa": "Spagnolo - Panama", "es-py": "Spagnolo - Paraguay", "es-pe": "Spagnolo - Per\xF9", "es-pr": "Spagnolo - Porto Rico", "es-es": "Spagnolo - Spagna", "es-us": "Snagnolo - Stati Uniti", "es-uy": "Spagnolo - Uruguay", "es-ve": "Spagnolo - Venezuela", "sw": "Swahili", "sv": "Svedese", "sv-fi": "Svedese - Finlandia", "sv-se": "Svedese - Svezia", "sy": "Siriaco", "ta": "Tamil", "tt": "Tatar", "te": "Telugu", "th": "Thai", "th-th": "Tailandese - Tailandia", "tl": "Tagalog", "tr": "Turco", "tr-tr": "Turco - Turchia", "uk": "Ucraino", "uk-ua": "Ucraino - Ucraina", "ur": "Urdu", "uz": "Uzbeko", "vi": "Vietnamita", "vi-vn": "Vietnamita - Vietnam", "yi": "Yiddish", "zu": "Zul\xF9" } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "SharedI18nStrings": {
    "af": "static-1.161",
    "ar-eg": "static-1.161",
    "ar-sa": "static-1.161",
    "ar": "static-1.161",
    "be": "static-1.161",
    "bg": "static-1.161",
    "bn": "static-1.161",
    "ca-es": "static-1.161",
    "ca": "static-1.161",
    "cs": "static-1.161",
    "da": "static-1.161",
    "de": "static-1.161",
    "el": "static-1.161",
    "en-gb": "static-1.161",
    "en": "static-1.161",
    "es-ar": "static-1.161",
    "es-es": "static-1.161",
    "es-mx": "static-1.161",
    "es": "static-1.161",
    "et": "static-1.161",
    "eu": "static-1.161",
    "fi": "static-1.161",
    "fr-ca": "static-1.161",
    "fr": "static-1.161",
    "gl": "static-1.161",
    "gu": "static-1.161",
    "he-il": "static-1.161",
    "he": "static-1.161",
    "hi": "static-1.161",
    "hr": "static-1.161",
    "hu": "static-1.161",
    "hy": "static-1.161",
    "id": "static-1.161",
    "is": "static-1.161",
    "it": "static-1.161",
    "ja": "static-1.161",
    "ka": "static-1.161",
    "kk": "static-1.161",
    "kn": "static-1.161",
    "ko": "static-1.161",
    "ky": "static-1.161",
    "lt": "static-1.161",
    "lv": "static-1.161",
    "mk": "static-1.161",
    "mn": "static-1.161",
    "mr": "static-1.161",
    "ms-my": "static-1.161",
    "ms": "static-1.161",
    "nl-be": "static-1.161",
    "nl-nl": "static-1.161",
    "nl": "static-1.161",
    "no": "static-1.161",
    "pl": "static-1.161",
    "pt-br": "static-1.161",
    "pt-pt": "static-1.161",
    "ro": "static-1.161",
    "ru": "static-1.161",
    "sk": "static-1.161",
    "sl": "static-1.161",
    "sq": "static-1.161",
    "sr": "static-1.161",
    "sv": "static-1.161",
    "sw": "static-1.161",
    "ta": "static-1.161",
    "te": "static-1.161",
    "th": "static-1.161",
    "tl": "static-1.161",
    "tr": "static-1.161",
    "uk": "static-1.161",
    "ur": "static-1.161",
    "vi": "static-1.161",
    "zh-cn": "static-1.161",
    "zh-hans": "static-1.161",
    "zh-hant": "static-1.161",
    "zh-hk": "static-1.161",
    "zh-tw": "static-1.161"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "it": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} gg", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}g", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, est. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "it": "static-7.1359"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1359",
    "ar-eg": "static-7.1359",
    "bg": "static-7.1359",
    "bn": "static-7.1359",
    "ca-es": "static-7.1359",
    "cs": "static-7.1359",
    "da": "static-7.1359",
    "de": "static-7.1359",
    "el": "static-7.1359",
    "en-gb": "static-7.1359",
    "en": "static-7.1359",
    "es-mx": "static-7.1359",
    "es": "static-7.1359",
    "et": "static-7.1359",
    "fi": "static-7.1359",
    "fr-ca": "static-7.1359",
    "fr": "static-7.1359",
    "he-il": "static-7.1359",
    "hi": "static-7.1359",
    "hr": "static-7.1359",
    "hu": "static-7.1359",
    "id": "static-7.1359",
    "it": "static-7.1359",
    "ja": "static-7.1359",
    "ko": "static-7.1359",
    "lt": "static-7.1359",
    "ms": "static-7.1359",
    "nl": "static-7.1359",
    "no": "static-7.1359",
    "pl": "static-7.1359",
    "pt-br": "static-7.1359",
    "pt-pt": "static-7.1359",
    "ro": "static-7.1359",
    "ru": "static-7.1359",
    "sk": "static-7.1359",
    "sl": "static-7.1359",
    "sv": "static-7.1359",
    "th": "static-7.1359",
    "tl": "static-7.1359",
    "tr": "static-7.1359",
    "uk": "static-7.1359",
    "vi": "static-7.1359",
    "x-pseudo": "static-7.1359",
    "zh-cn": "static-7.1359",
    "zh-hk": "static-7.1359",
    "zh-tw": "static-7.1359"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:it', {version: 'static-7.1359'}); }
})();



(function() {
  var result = { translations: { "it": { "videoPlayer": { "htmlTitle": "Video HubSpot", "htmlTitleWithVideo": "{{ videoTitle }} | HubSpot Video", "controls": { "audioPlayer": "Lettore audio", "videoPlayer": "Lettore video", "play": "Tasto play", "playVideo": "Riproduci video", "pause": "Metti in pausa", "replay": "Riproduci di nuovo", "currentTime": "Ora attuale", "duration": "Durata", "remainingTime": "Tempo rimanente", "fullscreen": "Schermo intero", "exitFullscreen": "Esci da schermo intero", "mute": "Disattiva audio", "unmute": "Riattiva audio", "volumeLevel": "Livello del volume", "captions": "Didascalie", "captionsOff": "Off", "seekBar": "Regola posizione", "chapter": "Capitolo", "elapsedTime": "Tempo trascorso: {{timeDisplay}}" }, "playbackOptions": { "buttonTitle": "Opzioni di riproduzione", "playbackRate": "Velocit\xE0 di riproduzione:", "quality": "Qualit\xE0:", "normal": "normale", "auto": "(automatica)" }, "formModal": { "defaultThankYouMessage": "Grazie per la risposta.", "inlineMessageButton": "Guarda video" }, "ctaModal": { "imgAlt": "CTA video" }, "errors": { "generic": { "heading": "Impossibile caricare il video" }, "UNAUTHORIZED": { "heading": "Video non abilitato" }, "VIDEO_NOT_FOUND": { "heading": "Video non trovato" }, "INVALID_URL": { "heading": "Video non trovato" }, "UNSUPPORTED_EMBED": { "heading": "Video non disponibile", "extra": "Questo video non pu\xF2 essere visualizzato esternamente." }, "refreshLink": "Riprova" } } } } };
  result.translationsLoaded = {
  "video-player-ui": {
    "it": "static-1.29208"
  }
};
  result.translationsAvailable = {
  "video-player-ui": {
    "af": "static-1.29208",
    "ar-eg": "static-1.29208",
    "bg": "static-1.29208",
    "bn": "static-1.29208",
    "ca-es": "static-1.29208",
    "cs": "static-1.29208",
    "da": "static-1.29208",
    "de": "static-1.29208",
    "el": "static-1.29208",
    "en-gb": "static-1.29208",
    "en": "static-1.29208",
    "es-mx": "static-1.29208",
    "es": "static-1.29208",
    "et": "static-1.29208",
    "fi": "static-1.29208",
    "fr-ca": "static-1.29208",
    "fr": "static-1.29208",
    "he-il": "static-1.29208",
    "hi": "static-1.29208",
    "hr": "static-1.29208",
    "hu": "static-1.29208",
    "id": "static-1.29208",
    "it": "static-1.29208",
    "ja": "static-1.29208",
    "ko": "static-1.29208",
    "lt": "static-1.29208",
    "ms": "static-1.29208",
    "nl": "static-1.29208",
    "no": "static-1.29208",
    "pl": "static-1.29208",
    "pt-br": "static-1.29208",
    "pt-pt": "static-1.29208",
    "ro": "static-1.29208",
    "ru": "static-1.29208",
    "sk": "static-1.29208",
    "sl": "static-1.29208",
    "sv": "static-1.29208",
    "th": "static-1.29208",
    "tl": "static-1.29208",
    "tr": "static-1.29208",
    "uk": "static-1.29208",
    "vi": "static-1.29208",
    "zh-cn": "static-1.29208",
    "zh-hk": "static-1.29208",
    "zh-tw": "static-1.29208"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:video-player-ui:it', {version: 'static-1.29208'}); }
})();


